import * as Sentry from '@sentry/react'

const environment = import.meta.env.VITE_FRONTEND_ENV

// Whitespace terminates the token as well as the usual URL delimiters, because breadcrumb
// messages are free text and a greedy match would eat the rest of the sentence.
const LAB_DOCUMENT_TOKEN = /(\/labs\/(?:r|doc|visit)\/)[^/?#\s]+/g

const QUERY_TOKEN = /([?&]token=)[^&#\s]+/g

/**
 * These tokens ARE the credential for the page that redeems them, so they must never leave the
 * request that uses them. Sentry would otherwise pick one up twice — once from the fetch
 * breadcrumb, once from the page URL attached to any event raised while the patient is on the page.
 */
export const redactTokens = (value: string) =>
  value.replace(LAB_DOCUMENT_TOKEN, '$1[redacted]').replace(QUERY_TOKEN, '$1[redacted]')

if (environment !== 'local') {
  Sentry.init({
    dsn: 'https://1aece0e31e41c1a33c0560a7ec6fa8d8@o4509673050734592.ingest.us.sentry.io/4509683233914882',
    environment,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,

    integrations: [],

    beforeBreadcrumb: (breadcrumb) => {
      for (const key of ['url', 'from', 'to'] as const) {
        if (typeof breadcrumb.data?.[key] === 'string') {
          breadcrumb.data[key] = redactTokens(breadcrumb.data[key])
        }
      }
      if (typeof breadcrumb.message === 'string') {
        breadcrumb.message = redactTokens(breadcrumb.message)
      }
      return breadcrumb
    },

    beforeSend: (event) => {
      if (event.request?.url) {
        event.request.url = redactTokens(event.request.url)
      }
      return event
    },
  })
}
